import { db } from "../firebaseClient"
import { doc, collection, setDoc, getDocs, query, where, serverTimestamp } from "firebase/firestore"

// Logs one external verification check — fired from getCertificate whenever
// the public /verify/:certId page is loaded. Anonymous by design: verifiers
// are typically employers/institutions, not logged-in Nesolearn users.
export const logVerificationEvent = async ({ certId, orgId, source = "public" }) => {
  if (!certId || !orgId) return { error: null }
  try {
    const ref = doc(collection(db, "verificationEvents"))
    await setDoc(ref, { certId, orgId, source, createdAt: serverTimestamp() })
    return { error: null }
  } catch (error) {
    return { error }
  }
}

export const listOrgVerificationEvents = async (orgId) => {
  try {
    const ref = collection(db, "verificationEvents")
    const q = query(ref, where("orgId", "==", orgId))
    const snap = await getDocs(q)
    return { events: snap.docs?.map((d) => d.data()), error: null }
  } catch (error) {
    return { events: [], error }
  }
}

// Joins raw verification events with the certificate they're about, so the
// panel doesn't need to cross-reference two arrays itself.
export const enrichVerificationEvents = (events, certificates) => {
  const certById = {}
  certificates?.forEach((c) => {
    certById[c.certId] = c
  })
  return (
    events
      ?.map((e) => ({ ...e, certificate: certById[e.certId] || null }))
      ?.sort((a, b) => (b?.createdAt?.toMillis?.() || 0) - (a?.createdAt?.toMillis?.() || 0)) || []
  )
}

export const computeVerificationSummary = (events, certificates) => {
  const publicEvents = events?.filter((e) => e?.source !== "admin") || []
  const byCert = {}
  publicEvents.forEach((e) => {
    byCert[e.certId] = (byCert[e.certId] || 0) + 1
  })

  const certById = {}
  certificates?.forEach((c) => {
    certById[c.certId] = c
  })

  const topCertificates = Object.entries(byCert)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5)
    .map(([certId, count]) => ({ certId, count, certificate: certById[certId] || null }))

  const issuedCount = certificates?.length || 0
  const verifiedAtLeastOnce = Object.keys(byCert).length

  return {
    totalVerifications: publicEvents.length,
    uniqueCredentialsVerified: verifiedAtLeastOnce,
    verificationRate: issuedCount > 0 ? Math.round((verifiedAtLeastOnce / issuedCount) * 100) : 0,
    topCertificates,
  }
}